/* eslint-disable prefer-const */
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {
  Avatar,
  Box,
  Button,
  Chip,
  Divider,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  tableCellClasses,
  Tooltip,
  useMediaQuery,
  useTheme,
  Tabs,
  Tab,
  Typography,
} from "@mui/material";
import Card from "../../../utils/Card";
import CardHeader from "../../../utils/CardHeader";
import MedicalHistory from "./MedicalHistory";
import { useEffect, useState } from "react";
import FamlilyHistory from "./FamilyHistory";
import SurgicalHistory from "./SurgicalHistory";
import SocialHistory from "./SocialHistory";
import Allergies from "./Allergies";
import { CARD_SHADOW } from "../../../utils/Constants";
import { styled } from "@mui/system";
import Slider from "react-slick";
import {
  ALLERGIES,
  FAMILY_HISTORY,
  MEAL_PREFERENCE,
  MEDICAL_HISTORY,
  MEDICAL_HISTORY_DIABETES,
  MEDICATION_HISTORY,
  PATIENT_HISTORY,
  PHYSICAL_ACTIVITY,
  SOCIAL_HISTORY,
  SURGICAL_HISTORY,
} from "../../../../../../shared/constants";
import { Next, Prev } from "./utils/arrows";
import { isPatientHistoryEmpty } from "./utils/shared";
import { useDispatch, useSelector } from "react-redux";
import {
  setEditRxSecMobile,
  setPrevPrescriptionDetails,
  setToggleRepopulateTable,
} from "../../../../../../redux/reducers/prescription.slice";
import { TabComponent, allyProps } from "../../../RightPanel";
import MealPreference from "./MealPreference";
import PhysicalActivity from "./PhysicalActivity";
import MedicationHistory from "./MedicationHistory";

const patientHistoryProps = {
  ["Medical History"]: true,
  ["Family History"]: false,
  ["Surgical History"]: false,
  ["Allergies"]: false,
  ["Social History"]: false,
  ["Meal Preference"]: false,
  ["Physical Activity"]: false,
  ["Medication History"]: false,
};

const StyledTableCell = styled(TableCell)({
  [`&.${tableCellClasses.body}`]: {
    padding: "16px",
    paddingLeft: 0,
    border: "none",
  },
});

const StyledChip = styled(Chip)({
  color: "#494E9D",
  backgroundColor: "#F2F3FF",
  fontSize: "13px",
  fontWeight: 400,
  lineHeight: "18px",
  borderRadius: "100px",
  letterSpacing: "0.16px",
  cursor: "pointer",
  userSelect: "none",
});

const EditButton = styled(Button)({
  width: 93,
  height: 32,
  border: "1px solid #494E9D",
  borderRadius: 4,
  color: "#494E9D",
  textTransform: "none",
});

const EmptyState: any = {
  MEDICAL_HISTORY: "No known significant medical history",
  FAMILY_HISTORY: "No known significant family history",
  SURGICAL_HISTORY: "No known significant surgical history",
  ALLERGIES: "No known allergies",
  SOCIAL_HISTORY: "No known significant social history",
  MEAL_PREFERENCE: "No known significant meal preference",
  PHYSICAL_ACTIVITY: "No known significant physical activity",
  MEDICATION_HISTORY: "No known significant medication history",
};

export default function PatientHistory(props: any) {
  const [data, setData] = useState<any>();
  const [loading, setLoading] = useState(true);
  const [showHistory, setShowHistory] = useState<any>(patientHistoryProps);
  const [toEdit, setEdit] = useState<boolean>();
  const [tabActive, setTabActive] = useState<number>(0);

  const sectionData = props.sectionData[0];
  const setTabData = props.setTabData;

  const theme = useTheme();
  const dispatch = useDispatch();
  const isMobileScreen = useMediaQuery(theme.breakpoints.down("md"));

  const isFocused: boolean = props.isFocused || false;
  const editSection = props?.editSection || false;
  const isSectionEmpty = props?.isSectionEmpty;
  const isAccExpanded = props?.sectionData?.[0]?.isExpanded;

  const {
    prescription: { prevPrescriptionDetails, rePopulateTable },
  } = useSelector((state: any) => state.prescription);

  const prevPatientHistory = prevPrescriptionDetails?.find(
    (section: any) => section.view_type === PATIENT_HISTORY
  );

  useEffect(() => {
    if (sectionData) {
      if (isSectionEmpty && prevPatientHistory && rePopulateTable) {
        if (!isPatientHistoryEmpty(prevPatientHistory)) {
          setTabData((prev: any) => {
            return prev.map((section: any) => {
              if (section.view_type === PATIENT_HISTORY) {
                return { ...prevPatientHistory };
              }
              return { ...section };
            });
          });
          dispatch(setToggleRepopulateTable(false));
        }
      } else {
        dispatch(setToggleRepopulateTable(false));
        setData(sectionData);
      }

      rePopulateTable && dispatch(setToggleRepopulateTable(false));


      if (isSectionEmpty && !isFocused) {
        setShowHistory(() => {
          return {
            ["Medical History"]: true,
            ["Family History"]: false,
            ["Surgical History"]: false,
            ["Allergies"]: false,
            ["Social History"]: false,
            ["Meal Preference"]: false,
            ["Physical Activity"]: false,
            ["Medication History"]: false,
          };
        });
      }
      setLoading(false);
    }
  }, [sectionData]);

  useEffect(() => {
    if (!isFocused) {
      setEdit(false);
    }
  }, [isFocused]);

  useEffect(() => {
    if (
      isSectionEmpty &&
      !data?.rows?.some((row: any) => row.disable_value === true) &&
      !rePopulateTable
    ) {
      setEdit(true);
    }
  }, [isSectionEmpty]);

  useEffect(() => {
    if (
      data &&
      isPatientHistoryEmpty(data) &&
      !data?.rows?.some((row: any) => row.disable_value === true) &&
      !rePopulateTable
    ) {
      setEdit(true);
    }
  }, [toEdit]);

  useEffect(() => {
    if (isAccExpanded && isSectionEmpty && isMobileScreen) {
      dispatch(setEditRxSecMobile(PATIENT_HISTORY));
    }
  }, [isAccExpanded]);

  const sliderSetting = {
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    infinite: false,
    prevArrow: (
      <Prev
        customStyles={{
          zIndex: "20",
          width: 24,
          height: 24,
          position: "absolute",
          left: "101%",
        }}
      />
    ),
    nextArrow: (
      <Next
        customStyles={{
          width: 24,
          height: 24,
          position: "absolute",
          right: "-55px",
        }}
      />
    ),
  };

  const sliderMobileSetting = {
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    infinite: false,
    prevArrow: (
      <Prev
        customStyles={{
          zIndex: "20",
          width: 20,
          height: 20,
          position: "absolute",
          left: "88%",
          top: "-10px",
        }}
      />
    ),
    nextArrow: (
      <Next
        customStyles={{
          width: 20,
          height: 20,
          position: "absolute",
          right: "-12px",
          top: "-10px",
        }}
      />
    ),
  };

  const isFieldDisabled = () => {
    const disabledFields = data?.rows?.filter(
      (row: any) => row.disable_value === true
    );

    if (disabledFields?.length === 0) return ShowEditableContent();

    const viewTypes = disabledFields?.map((row: any) => row.view_type);

    return (
      <Box
        sx={{
          color: "#959595",
          fontWeight: 400,
          lineHeight: "132%",
        }}
        component="span"
      >
        {viewTypes?.map((view: any) => EmptyState[view]).join(", ")}
      </Box>
    );
  };

  const renderComplaints = (view_type: string, value: Array<any>) => {
    const EmptyValueLabel = () => {
      return (
        <StyledTableCell
          sx={{
            display: "flex",
            flexDirection: "column",
            borderBottom: isMobileScreen ? "none" : "1px solid #eee",
            padding: isMobileScreen ? "8px 8px 8px 0px" : "16px",
          }}
          key={view_type}
        >
          <Box
            sx={{
              color: "#000",
              fontSize: "14px",
              fontWeight: 700,
              lineHeight: "132%",
              marginBottom: "5px",
            }}
            component="span"
          >
            {EmptyState[view_type]}
          </Box>
        </StyledTableCell>
      );
    };

    if (
      view_type === SOCIAL_HISTORY &&
      value?.every((val) => val?.status?.length === 0)
    ) {
      return <EmptyValueLabel />;
    }

    if (
      view_type === MEDICATION_HISTORY &&
      !value[0]?.value
    ) {
      return <EmptyValueLabel />;
    }

    if (value?.length > 0) {
      return value?.map((item: any) => {
        let { name, status, since, when, category } = item;
        let label, icons;

        switch (view_type) {
          case MEDICAL_HISTORY:
            label = `${status}${
              status !== "Never Had"
                ? `${status.length !== 0 ? ` | ` : ""} ${
                    status === "Resolved" ? when : since
                  }`
                : ""
            }`;
            break;
          case FAMILY_HISTORY:
            label = (
              <Tooltip arrow title={item.relation.join(", ")}>
                {item.relation.length <= 2
                  ? item.relation.join(", ")
                  : `${item.relation.slice(0, 2).join(", ")}...`}
              </Tooltip>
            );
            break;
          case SURGICAL_HISTORY:
            label = when;
            break;
          case ALLERGIES:
            label = category;
            break;
          case SOCIAL_HISTORY:
            if (status?.length !== 0) {
              label = status;
            }
            icons = [...value.map((elem) => elem.name)];
            break;
          case MEAL_PREFERENCE:
            name = item.state
            break;
          case PHYSICAL_ACTIVITY:
            name = item.state
            break;
          case MEDICATION_HISTORY:
            name = item.value?.replace(/(<p[^>]+?>|<p>|<\/p>)/img, "");
            break;
        }

        const content = (
          <>
            <Box
              sx={{
                color: "#000",
                fontSize: "14px",
                fontWeight: 700,
                lineHeight: "132%",
                marginBottom: "5px",
              }}
              component="span"
            >
              {name}
            </Box>
            {label && (
              <Box
                sx={{
                  color: "#878787",
                  fontWeight: 400,
                  lineHeight: "132%",
                }}
                component="span"
              >
                {label}
              </Box>
            )}
          </>
        );

        return (
          <>
            <StyledTableCell
              className="histories"
              sx={{
                display: "flex",
                flexDirection: "column",
                borderBottom: isMobileScreen ? "none" : "1px solid #eee",
                padding: isMobileScreen ? "8px 8px 8px 0px" : "16px",
                maxWidth:  !isMobileScreen ? "200px" : undefined,
                wordWrap: !isMobileScreen ? "break-word" : undefined,
                
              }}
              key={name}
            >
              {Array.isArray(icons) && icons.length !== 0 ? (
                <Box
                  className="SociakHistory"
                  sx={{ display: "flex", alignItems: "center" }}
                >
                  <span style={{ marginRight: "9px" }}>
                    <img
                      src={`/images/${
                        icons.filter((iName: any) => iName === name)[0]
                      }.svg`}
                    />
                  </span>
                  <Box
                    className="SociakHistory"
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: isMobileScreen
                        ? "space-between"
                        : "center",
                    }}
                  >
                    {content}
                  </Box>
                </Box>
              ) : (
                content
              )}
            </StyledTableCell>
          </>
        );
      });
    }

    return <EmptyValueLabel />;
  };

  const getValueContainerWidth = () => {
    const tableRow: any = document.querySelector(
      "#preview-medical-histories tr"
    );
    const labelCell: any = tableRow?.querySelector(`td`);
    const width: any = tableRow?.clientWidth - labelCell?.clientWidth;

    return width;
  };

  const ShowTableView = () => {
    return (
      <Box>
        <TableContainer
          sx={{
            boxShadow: "none",
            overflow: "hidden",
          }}
        >
          <Table
            sx={{ minWidth: 650 }}
            aria-label="preview-medical-histories"
            id="preview-medical-histories"
          >
            <TableBody>
              {sectionData?.rows?.map((pHistory: any) => {
                const { header, view_type, value } = pHistory;
                return (
                  <>
                    <TableRow
                      key={view_type}
                      sx={{ borderBottom: "1px solid #E6E6E6" }}
                    >
                      <StyledTableCell id={header} align="left">
                        <StyledChip
                          clickable={false}
                          sx={{
                            width: 157,
                            height: 35,
                            borderRadius: 24,
                            fontWeight: 600,
                            lineHeight: "19px",
                            letterSpacing: "-0.28px",
                            cursor: "auto",
                          }}
                          label={header}
                        />
                      </StyledTableCell>
                      {Array.isArray(value) && value.length > 4 ? (
                        <Box
                          key={view_type + " values"}
                          sx={{
                            width: !isNaN(getValueContainerWidth())
                              ? getValueContainerWidth() - 50
                              : 650,
                            maxWidth: getValueContainerWidth(),
                          }}
                        >
                          <Slider {...sliderSetting}>
                            {renderComplaints(view_type, value)}
                          </Slider>
                        </Box>
                      ) : (
                        <Box
                          sx={{
                            display: "flex",
                          }}
                        >
                          {renderComplaints(view_type, value)}
                        </Box>
                      )}
                    </TableRow>
                  </>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    );
  };

  const ShowEditableContent = () => {
    const MedicalHistoryRef = (
      <MedicalHistory
        setTabData={setTabData}
        sectionData={data?.rows.filter(
          (section: any) => section.view_type === MEDICAL_HISTORY
        )}
      />
    );
    const FamilyHistoryRef = (
      <FamlilyHistory
        setTabData={setTabData}
        sectionData={data?.rows.filter(
          (section: any) => section.view_type === FAMILY_HISTORY
        )}
      />
    );
    const SurgicalHistoryRef = (
      <SurgicalHistory
        setTabData={setTabData}
        sectionData={data?.rows.filter(
          (section: any) => section.view_type === SURGICAL_HISTORY
        )}
      />
    );
    const AllergiesRef = (
      <Allergies
        setTabData={setTabData}
        sectionData={data?.rows.filter(
          (section: any) => section.view_type === ALLERGIES
        )}
      />
    );

    const SocialHistoryRef = (
      <SocialHistory
        setTabData={setTabData}
        sectionData={data?.rows.filter(
          (section: any) => section.view_type === SOCIAL_HISTORY
        )}
      />
    );

    const MealPreferenceRef = (
      <MealPreference
        setTabData={setTabData}
        sectionData={data?.rows.filter(
          (section: any) => section.view_type === MEAL_PREFERENCE
        )}
      />
    );

    const PhysicalActivityRef = (
      <PhysicalActivity
        setTabData={setTabData}
        sectionData={data?.rows.filter(
          (section: any) => section.view_type === PHYSICAL_ACTIVITY
        )}
      />
    );

    const MedicationHistoryRef = (
      <MedicationHistory
        setTabData={setTabData}
        sectionData={data?.rows.filter(
          (section: any) => section.view_type === MEDICATION_HISTORY
        )}
      />
    );
    if (!isMobileScreen) {
      return (
        <>
          {showHistory["Medical History"] && MedicalHistoryRef}
          {showHistory["Family History"] && FamilyHistoryRef}
          {showHistory["Surgical History"] && SurgicalHistoryRef}
          {showHistory["Allergies"] && AllergiesRef}
          {showHistory["Social History"] && SocialHistoryRef}
          {showHistory["Meal Preference"] && MealPreferenceRef}
          {showHistory["Physical Activity"] && PhysicalActivityRef}
          {showHistory["Medication History"] && MedicationHistoryRef}

          <>
            {Object.values(showHistory).includes(false) && (
              <>
                <Divider sx={{ mx: 0, mb: 2 }} variant="middle" />
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <span
                    style={{
                      fontSize: "14px",
                      fontWeight: "400",
                      marginRight: "16px",
                      color: "#000000",
                      opacity: "87%",
                    }}
                  >
                    Add
                  </span>
                  <Box display={'flex'} flexWrap={'wrap'} gap={2}>
                    {Object.entries(showHistory).map((arr) => {
                      const [key, value] = arr;
                      if (!value) {
                        return (
                          <Box
                            sx={{ cursor: "pointer" }}
                            onClick={(e) => {
                              const target = e.currentTarget as HTMLElement;
                              const ariaLabel = target.ariaLabel as string;
                              setShowHistory({
                                ...showHistory,
                                [ariaLabel]: true,
                              });
                            }}
                            aria-label={key}
                            key={key}
                          >
                            <StyledChip
                              sx={{ pointerEvents: "none" }}
                              avatar={
                                <Avatar alt="" src="/images/icon_add.svg" />
                              }
                              label={key}
                            />
                          </Box>
                        );
                      }
                    })}
                  </Box>
                  
                </Box>
              </>
            )}
          </>
        </>
      );
    }
    return (
      <>
        <TabComponent tabActive={tabActive} index={0}>
          {MedicalHistoryRef}
        </TabComponent>
        <TabComponent tabActive={tabActive} index={1}>
          {FamilyHistoryRef}
        </TabComponent>
        <TabComponent tabActive={tabActive} index={2}>
          {SurgicalHistoryRef}
        </TabComponent>
        <TabComponent tabActive={tabActive} index={3}>
          {AllergiesRef}
        </TabComponent>
        <TabComponent tabActive={tabActive} index={4}>
          {SocialHistoryRef}
        </TabComponent>
        <TabComponent tabActive={tabActive} index={5}>
          {MealPreferenceRef}
        </TabComponent>
        <TabComponent tabActive={tabActive} index={6}>
          {PhysicalActivityRef}
        </TabComponent>
        <TabComponent tabActive={tabActive} index={7}>
          {MedicationHistoryRef}
        </TabComponent>
      </>
    );
  };

  const RenderReadOnly = () => {
    return (
      <Box>
        {data?.rows?.map((item: any) => {
          return (
            <Box>
              <Box>
                <Typography
                  sx={{
                    fontSize: "14px",
                    fontWeight: "600",
                    color: "rgba(73, 78, 157, 1)",
                  }}
                >
                  {item?.header}
                </Typography>
              </Box>
              {item?.value?.length > 3 ? (
                <Box className="slider-container">
                  <Slider {...sliderMobileSetting}>
                    {renderComplaints(item?.view_type, item?.value)}
                  </Slider>
                </Box>
              ) : (
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                  {renderComplaints(item?.view_type, item?.value)}
                </Box>
              )}
            </Box>
          );
        })}
      </Box>
    );
  };

  const RenderData = () => {
    if (!isPatientHistoryEmpty(sectionData)) {
      return ShowTableView();
    }
    return isFieldDisabled();
  };

  return (
    <>
      {loading && (
        <>
          <Skeleton animation="wave" />
          <Skeleton animation="wave" />
        </>
      )}
      {!loading && !isMobileScreen && (
        <Card
          styles={{
            boxShadow: `${isFocused ? CARD_SHADOW : "none"}`,
          }}
          title="Patient History"
          isReadOnly={props?.isReadOnly}
        >
          <CardHeader
            headerImg="icon_patient_history.svg"
            headerTitle="Patient History"
          >
            {!toEdit &&
              (!isPatientHistoryEmpty(sectionData) ||
                sectionData.rows.some(
                  (row: any) => row.disable_value === true
                )) && (
                <EditButton onClick={() => setEdit(true)}>Edit</EditButton>
              )}
          </CardHeader>
          {toEdit && ShowEditableContent()}
          {toEdit === false && RenderData()}
        </Card>
      )}
      {!loading && isMobileScreen && !editSection && RenderReadOnly()}
      {!loading && isMobileScreen && editSection && (
        <>
          <Divider sx={{ mx: 0 }} variant="middle" />
          <Box sx={{ width: "100%" }}>
            <Box
              sx={{
                background: "transparent",
              }}
            >
              <Tabs
                value={tabActive}
                onChange={(_e, newValue) => {
                  setTabActive(newValue);
                }}
                variant="scrollable"
                scrollButtons="auto"
              >
                {Object.entries(showHistory).map((arr, index) => {
                  const [key] = arr;
                  return <Tab label={key} {...allyProps(index)} />;
                })}
              </Tabs>
            </Box>
            {ShowEditableContent()}
          </Box>
        </>
      )}
    </>
  );
}
